export enum Networks {
  mainnet = 1,
  ropsten = 3,
  rinkeby = 4,
  goerli = 5,
  optimism = 10,
  kovan = 42,
  matic = 137,
  kovanOptimism = 69,
  xdai = 100,
  xDaiTestnet = 10200,
  goerliOptimism = 420,
  arbitrum = 42161,
  rinkebyArbitrum = 421611,
  goerliArbitrum = 421613,
  mumbai = 80001,
  sepolia = 11155111,
  avalancheMainnet = 43114,
  avalancheFuji = 43113,
  fantomTestnet = 4002,
  fantom = 250,
  bsc = 56,
  bsc_testnet = 97,
  moonbeam = 1284,
  moonriver = 1285,
  moonbaseAlphaTestnet = 1287,
  harmony = 1666600000,
  cronos = 25,
  fuse = 122,
  songbirdCanaryNetwork = 19,
  costonTestnet = 16,
  boba = 288,
  aurora = 1313161554,
  astar = 592,
  okc = 66,
  heco = 128,
  metis = 1088,
  rsk = 30,
  rskTestnet = 31,
  evmos = 9001,
  evmosTestnet = 9000,
  thundercore = 108,
  thundercoreTestnet = 18,
  oasis = 26863,
  celo = 42220,
  godwoken = 71402,
  godwokentestnet = 71401,
  klatyn = 8217,
  milkomeda = 2001,
  kcc = 321,
  etherlite = 111,
  lineaTestnet = 59140,
  linea = 59144,
  scroll = 534352,
  scrollSepolia = 534351,
  zkSyncEra = 324,
  zkSyncEraTestnet = 280,
  shibarium = 109,
  mantle = 5000,
  mantleTestnet = 5001,
  base = 8453,
  baseTestnet = 84531,
  polygonZkEvm = 1101,
  polygonZkEvmTestnet = 1442,
  zora = 7777777,
  zoraTestnet = 999,
  flare = 14,
  pulsechain = 369,
  sophonsepolia = 531050104,
}
